//Average soak / tow time
export const AVG_SOAK_TIME_MIN_FORMAT = "avg_soak_time_min_format";
export const AVG_SOAK_TIME_FORMAT = "avg_soak_time_format";
export const AVG_SOAK_TIME_EMPTY = "avg_soak_time_empty";

//"Buoy Lines"
export const BUOY_LINES_EMPTY = "bouy_lines_empty";
export const BUOY_LINES_FORMAT = "buoy_lines_format";

//"total String hauled"
export const STRINGS_HAULED_FORMAT = "strings_hauled_format";
export const STRINGS_HAULED_EMPTY = "strings_hauled_empty";

//trapsPerString
export const AVG_NUMBER_TRAPS_INVALID = "avg_number_traps_invalid";
export const AVG_NUM_TRAPS_EMPTY = "avg_num_traps_empty";

//"Trips in water
export const TOTAL_TRAPS_WATER_INVALID = "total_traps_water_invalid";
export const TOTAL_TRAPS_WATER_EMPTY = "total_traps_water_empty";

export const DATE_LAND_AFTER = "date_land_after";
export const DATE_LAND_EMPTY = "date_land_empty";
export const DATE_LAND_BEFORE = "date_land_before";

// Traps/Pots in water
export const TRAPS_IN_WATER_EMPTY = "traps_in_water_empty";
export const TRAPS_IN_WATER_FORMAT = "traps_in_water_format";

export const LINES_IN_WATER_EMPTY = "lines_in_water_empty";
export const LINES_IN_WATER_FORMAT = "lines_in_water_format";

export const TRAPS_PER_EFFORT_EMPTY = "traps_per_effort_empty";
export const TRAPS_PER_EFFORT_FORMAT = "traps_per_effort_format";

export const TRAPS_PER_STRING_EMPTY = "traps_per_string_empty";
export const TRAPS_PER_STRING_FORMAT = "traps_per_string_format";

// Local storage errors
const CONTACT_MESSAGE =
  "Please contact 978-281-9188 for error reporting and technical support.";
export const QUOTA_EXCEEDED_ALERT = "Local Storage is full. " + CONTACT_MESSAGE;
export const QUOTA_EXCEEDED_ERROR = "QuotaExceededError";
export const UNEXPECTED_ERROR = "An unexpected error has occurred. " + CONTACT_MESSAGE;

// Coordinates errors
export const LAT_LON_FORMAT_ERROR = "No Latitude Longitude format selected";
export const MINIMUM_DECIMAL_ERROR =
  "Minimum of four decimal places required for latitude/longitude";
export const MINIMUM_LAT_DECIMAL_ERROR =
  "Minimum of four decimal places required for latitude";
export const MINIMUM_LON_DECIMAL_ERROR =
  "Minimum of four decimal places required for longitude";
export const LAT_DECIMAL_DEGREES_EMPTY = "No Latitude provided";
export const LON_DECIMAL_DEGREES_EMPTY = "No Longitude provided";
